'use strict';
module.exports = function (obj, cb) {
	var ret = {};
	var keys = Object.keys(obj);

	for (var i = 0; i < keys.length; i++) {
		var key = keys[i];
		var res = cb(key, obj[key], obj);
		ret[res[0]] = res[1];
	}

	return ret;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/map-obj/index.js
 ** module id = 1357
 ** module chunks = 0
 **/